import React from 'react';
import { NeueToggleComponent } from '../toggle/component';

interface Props {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  icon?: JSX.Element;
  disabled?: boolean;
  label: string;
}

export const ControlPanelSwitchButton = ({ label, onChange, checked = false, disabled, icon }: Props) => (
  <NeueToggleComponent
    icon={icon}
    label={label}
    wrapperClassName='py-0 px-2 transition-colors bg-transparent hover:bg-neue-journey-fg-10 rounded-lg'    labelWrapperClassName='h-10'
    switchClassName='m-auto'
    checked={checked}
    disabled={disabled}
    onChange={onChange}
    labelType='regular'
  />
);
